<template>
	<div class="user_feedback_list clearfix p_background">
		<h3 class="all_title">用户反馈</h3>
		
		<section class="all_container container_box">
			
			<!--all state start-->
			<div class="all_state clearfix">
				<div class="state_left">
					<ul>
						<li id="manage_all" class="state_active" @click="initData('')">全部</li>
						<li id="manage_all1" class="state_active" @click="initData('1')">已回复（{{answer1count}}）</li>
						<li id="manage_all2" class="state_active" @click="initData('0')">未回复（{{answer0count}}）</li>
					</ul>
				</div>
				<!--<div class="state_center text-right">
					<section class="search_box">
						<input id="manage_app_query" type="text" class="search_control" placeholder="输入应用名称查询" />
						<i class="glyphicon icon_search" @click=""></i>
					</section>
				</div>-->
			</div>
			<!--all state end-->
			
			<div class="table_box clearfix">
				<table class="table table-hover text-center">
					<thead>
						<tr>
							<th>归属学校</th>
							<th>反馈类型</th>
							<th>提交时间</th>
							<th>反馈人</th>
							<th>操作</th>
						</tr>
					</thead>
					<tbody class="color_3">
						<tr v-for="(feedback,index) in page.content">
							<td>{{feedback.schoolName}}</td>
							<td v-if="feedback.feedbackType == '1'">平台反馈</td>
							<td v-if="feedback.feedbackType == '2'">意见建议</td>
							<td v-if="feedback.feedbackType == '3'">应用反馈<span v-if="feedback.appName != null">-{{feedback.appName}}</span></td>
							<td>{{feedback.feedbackTime | datetime}}</td>
							<td>{{feedback.schoolcloudUserUsername}}</td>
							<td>
								<div v-if="feedback.answerStatus == '1'" class="line_block">
									<span class="margin_r_7">已回复</span>
									<a @click="view(feedback.id,'feedback_detail')" class="btn_text">查看</a>
								</div>
								<a v-if="feedback.answerStatus == '0'" @click="view(feedback.id,'feedback_reply')" class="btn_text">回复</a>
							</td>
						</tr>
						<tr v-if="page.content == ''">
							<td colspan="5">暂无数据</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="text-center" v-bind:class="page.totalPages &gt; 0 ? 'show' : 'hidden'">
				<div class="row-fluid">
					<nav>
						<ul class="pagination">
							<li class="disabled" v-bind:class="page.first ? 'disabled' : ''">
								<a style="cursor: pointer;" @click="turnPage(page.url,page.previousPage)" aria-label="Previous">
									<span aria-hidden="true">&laquo;</span>
								</a>
							</li>
							<li v-for="i in page.totalPages" v-bind:class="page.number==(i-1)?'active':''">
								<a style="cursor: pointer;" @click="turnPage(page.url,i-1)" v-text="i">1</a>
							</li>
							<li v-bind:class="page.last ? 'disabled' : ''">
								<a style="cursor: pointer;" @click="turnPage(page.url,page.nextPage)" aria-label="Next">
									<span aria-hidden="true">&raquo;</span>
								</a>
							</li>
						</ul>
					</nav>
				</div>
			</div>
			
		</section>
	</div>
</template>

<script>
	
	export default {
		data() {
			return {
				answer0count: '',
				answer1count: '',
				status: '',
				page:'',
	            }
		},
		mounted: function() {
			this.$nextTick(function() {
				
			})
		},
		// 页面初始化
		created: function() {
			this.initData('');
		},
		methods: {
			initData(status) {
				var _this = this;
				_this.status = status;
				
				this.$http.post('/zklccloud/queryFeedbackListByAdmin', { "status": status },{ emulateJSON: true }).then(function(m) {
					_this.page = m.data.content.page,
					_this.answer0count = m.body.content.answer0count,
					_this.answer1count = m.body.content.answer1count
				})
			},
			//分页
	    	turnPage(pageUrl,page){
		    	var temp = this;
		      	this.$http.post('/zklccloud/'+pageUrl,{"status": temp.status,"page": page,"size": 10},{emulateJSON:true}).then(function(m){
		      		temp.page = m.data.content.page
		      })
	    	},
	    	//根据id查询反馈详情
		    view(id,obj){
		    	this.$router.push({name: obj,params:{feedbackId:id}});
		    },
		}
	}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// list.vue?0acbb380